import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';
import { CommonService } from '../../services/common.service';
import { SharedModule } from '../../shared/shared.module';
import { CompanyRouting } from './company.routing';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';
import { MatTabsModule } from '@angular/material/tabs';
import { HasRoleDirective } from '../../shared/directives/has-role.directive';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CompanyComponent } from './components/company.component';
import { CompanyDashboardComponent } from './components/company-dashboard/company-dashboard.component';
import { CompanyOrderListComponent } from './components/company-order-list/company-order-list.component';
import { CompanyPhotographerDetailComponent } from './components/company-photographer-detail/company-photographer-detail.component';
import { CompanyPhotographerListComponent } from './components/company-photographer-list/company-photographer-list.component';
import { CompanyStyleDetailComponent } from './components/company-style-detail/company-style-detail.component';
import { CompanyStyleListComponent } from './components/company-style-list/company-style-list.component';
import { CompanyOrderDetailInfoComponent } from './components/company-order-detail/company-order-detail-info/company-order-detail-info.component';
import { AddProductModalComponent } from './components/company-order-detail/company-order-detail-shots/add-product-modal/add-product-modal.component';
import { ApproveOrderNoteComponent } from './components/company-order-detail/company-order-detail-shots/approve-order-note/approve-order-note';
import { CompanyOrderDetailComponent } from './components/company-order-detail/company-order-detail.component';
import { CompanyOrderDetailShotsComponent } from './components/company-order-detail/company-order-detail-shots/company-order-detail-shots.component';
import { CompanyTemplateListComponent } from './components/company-template-list/company-template-list.component';
import { CompanyExportTemplateListComponent } from './components/company-third-parties-applications/company-export-template-list/company-export-template-list.component';
import { CompanyTemplateDetailComponent } from './components/company-template-detail/company-template-detail.component';
import { CompanyExportTemplateDetailComponent } from './components/company-third-parties-applications/company-export-template-detail/company-export-template-detail.component';
import { CompanyThirdPartiesApplicationsComponent } from './components/company-third-parties-applications/company-third-parties-applications.component';
import { CompanyLegacyImageFormatsComponent } from './components/company-third-parties-applications/company-legacy-image-formats/company-legacy-image-formats.component';
import { LegacyImageFormatModalComponent } from './components/company-third-parties-applications/company-legacy-image-formats/legacy-image-format-modal/legacy-image-format-modal.component';
import { AddShotModalComponent } from './components/company-template-detail/add-shot-modal/add-shot-modal.component';
import { OrdersModalComponent } from './components/company-style-list/orders-modal/orders-modal.component';
import { WarehouseArticleResumeeModalComponent } from './components/company-style-list/warehouse-article-resumee-modal/warehouse-article-resumee-modal.component';
import { AddToOrderModalComponent } from './components/company-style-list/add-to-order-modal/add-to-order-modal.component';
import { AddToOrderChooseModalComponent } from './components/company-style-list/add-to-order-choose-modal/add-to-order-choose-modal.component';
import { CreateOrderModalComponent } from './components/company-style-list/create-order-modal/create-order-modal.component';
import { SelectedStylesModalComponent } from './components/company-style-list/selected-styles-modal/selected-styles-modal.component';
import { AddToOrderConfirmModalComponent } from './components/company-style-list/add-to-order-confirm-modal/add-to-order-confirm-modal.component';
import { ManageColorsSizesModalComponent } from './components/company-order-detail/company-order-detail-shots/add-product-modal/manage-colors-sizes-modal/manage-colors-sizes-modal.component';
import { SubmitOrderModalComponent } from './components/company-order-detail/company-order-detail-shots/submit-order-modal/submit-order-modal.component';
import { PhotographerStatusModalComponent } from './components/company-photographer-detail/photographer-status-modal/photographer-status-modal.component';
import { AllIsApprovedModalComponent } from './components/company-order-detail/company-order-detail-shots/all-is-approved-modal/all-is-approved-modal.component';
import { OrderReadyForPickupModalComponent } from './components/company-order-detail/company-order-detail-shots/order-ready-for-pickup-modal/order-ready-for-pickup-modal.component';
import { OrderProgressModalComponent } from './components/company-order-detail/company-order-detail-shots/order-progress-modal/order-progress-modal.component';
import { OrderApproveModalComponent } from './components/company-order-detail/company-order-detail-shots/order-approve-modal/order-approve-modal.component';
import { OrderCostChangesModalComponent } from './components/company-order-detail/company-order-detail-shots/order-cost-changes-modal/order-cost-changes-modal.component';
import { SetFinalCostModalComponent } from './components/company-order-detail/company-order-detail-shots/set-final-cost-modal/set-final-cost-modal.component';
import { MediaVisualizerComponent } from './components/media-visualizer/media-visualizer.component';
import { CompanyRoleSettingsComponent } from './components/company-role-settings/company-role-settings.component';
import { AddUserProfileRoleModalComponent } from './components/company-role-settings/add-user-profile-role-modal/add-user-profile-role-modal.component';
import { RolePipe } from './pipes/role.pipe';
import { CompanyInsightStylePriceComponent } from './components/company-insight-style-price/company-insight-style-price.component';
import { CompanyMediaShareLinkListComponent } from './components/company-media-share-link-list/company-media-share-link-list.component';
import { CompanyShotTypesListComponent } from './components/company-shot-types-list/company-shot-types-list.component';
import { ShotTypeModalComponent } from './components/company-shot-types-list/shot-type-modal/shot-type-modal.component';
import { CompanyMediaShareLinkDetailComponent } from './components/company-media-share-link-detail/company-media-share-link-detail.component';
import { CompanyMediaShareLinkDetailMenuComponent } from './components/company-media-share-link-detail/company-media-share-link-detail-menu/company-media-share-link-detail-menu.component';
import { CompanyMediaShareLinkDetailProductComponent } from './components/company-media-share-link-detail/company-media-share-link-detail-product/company-media-share-link-detail-product.component';
import { CreateMediaShareLinkModalComponent } from './components/company-media-share-link-list/create-media-share-link-modal/create-media-share-link-modal.component';
import { ManageColorsModalComponent } from './components/company-media-share-link-list/create-media-share-link-modal/manage-colors-modal/manage-colors-modal.component';
import { MediaHistoryModalComponent } from './components/company-style-detail/media-history-modal/media-history-modal.component';
import { UserGuidesComponent } from '../../shared/components/user-guides/user-guides.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgChartsModule,
    SharedModule,
    CompanyRouting,
    A11yModule,
    UiAvatarImageComponent,
    UpTopHeaderComponent,
    UserGuidesComponent,
    // Material Import:
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatChipsModule,
    MatIconModule,
    MatTabsModule,
    HasRoleDirective,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatExpansionModule,
    DragDropModule
  ],
  declarations: [
    CompanyComponent,
    CompanyDashboardComponent,
    CompanyOrderListComponent,
    CompanyStyleListComponent,
    CompanyPhotographerListComponent,
    CompanyTemplateListComponent,
    CompanyExportTemplateListComponent,
    CompanyThirdPartiesApplicationsComponent,
    CompanyLegacyImageFormatsComponent,
    LegacyImageFormatModalComponent,
    CompanyTemplateDetailComponent,
    CompanyExportTemplateDetailComponent,
    CompanyStyleDetailComponent,
    ApproveOrderNoteComponent,
    CompanyPhotographerDetailComponent,
    PhotographerStatusModalComponent,
    AddProductModalComponent,
    CompanyOrderDetailComponent,
    CompanyOrderDetailInfoComponent,
    CompanyOrderDetailShotsComponent,
    AddShotModalComponent,
    OrdersModalComponent,
    WarehouseArticleResumeeModalComponent,
    AddToOrderModalComponent,
    AddToOrderChooseModalComponent,
    CreateOrderModalComponent,
    SelectedStylesModalComponent,
    AddToOrderConfirmModalComponent,
    ManageColorsSizesModalComponent,
    SubmitOrderModalComponent,
    AllIsApprovedModalComponent,
    OrderReadyForPickupModalComponent,
    OrderProgressModalComponent,
    OrderApproveModalComponent,
    OrderCostChangesModalComponent,
    SetFinalCostModalComponent,
    MediaVisualizerComponent,
    CompanyRoleSettingsComponent,
    AddUserProfileRoleModalComponent,
    RolePipe,
    CompanyInsightStylePriceComponent,
    CompanyMediaShareLinkListComponent,
    CompanyMediaShareLinkDetailComponent,
    CompanyMediaShareLinkDetailMenuComponent,
    CompanyMediaShareLinkDetailProductComponent,
    CreateMediaShareLinkModalComponent,
    ManageColorsModalComponent,
    MediaHistoryModalComponent,
    CompanyShotTypesListComponent,
    ShotTypeModalComponent
  ],
  exports: [CompanyComponent],
  providers: [CommonService],

})
export class CompanyModule {}
